var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./AwardsHonoredPopup.jinja');
require('./AwardsHonoredPopup.less');

var CommonHonoredList = require('front/components/CommonHonoredList/CommonHonoredList');
var CommonSidebar = require('front/components/CommonSidebar/CommonSidebar');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonHonoredList': {selector: '.CommonHonoredList', viewConstructor: CommonHonoredList},
        'CommonSidebar': {selector: '.CommonSidebar', viewConstructor: CommonSidebar}
    },

    events: _.extend({

    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        return Urls['front:api:awards_honored-popup'](this.category, this.person, 'json');
    },

    renderData: function () {
        return {
            popup: this.data || {}
        };
    },

    initialize: function (options) {
        this.options = options || {};

        this.category = this.options.category;
        this.person = this.options.person;

        BasePopup.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsHonoredPopup/AwardsHonoredPopup.js
// module id = 259
// module chunks = 0